function Visionmission(){
    return(
        <div className="Vision">
        <p className="vision">Vision</p><p className="vistext">Aims at developing STJIT as a premier technical institution by excelling in every aspect of technical education.</p>
        <p className="mission">Mission</p><p className="vistext">Imparting technical education and training in response to the changing needs of industry and society, believing in quality, innovation, ethical and moral standards.</p>
        </div>
    );
}
export default Visionmission;